import { useEffect, useState } from "react";

import { appAssetsService } from "@/services/app-assets.service";

/**
 * Resolves a public asset filename to a signed S3 URL, returning an empty
 * string until signing completes or if it fails.
 */
export const useS3VideoUrl = (fileName: string): string => {
  const [videoUrl, setVideoUrl] = useState("");

  useEffect(() => {
    appAssetsService
      .getVideoSignedUrl(fileName)
      .then(setVideoUrl)
      .catch(() => {});
  }, [fileName]);

  return videoUrl;
};
